import React from 'react';
import styled from 'styled-components/macro';
import { Helmet } from 'react-helmet';
import { Header, Footer } from '.';
import { useLogPageView } from 'hooks';
import { Flex, Box } from 'components/ui';
import {
  background,
  color,
  layout,
  space,
} from 'styled-system';
import WarningMessage from 'components/WarningMessage';

const Wrapper: any = styled.div`
  width: 100%;
  min-height: 100vh;
  ${background};
  ${color};
`;

const Content: any = styled.div<any>`
  width: 100%;
  padding: ${props => props.padding || '40px 16px 0 16px'};
  ${space};
  ${layout};
`;

// interface PageProps {
//   children: object;
//   title?: string;
//   name?: string;
//   showHeader?: boolean;
//   showFooter?: boolean;
//   fixedFooter?: boolean;
//   headerBg?: string;
//   headerBackground?: string;
//   background?: string;
//   showTitle?: boolean;
// }

const linearGradient =
  'linear-gradient(350deg, rgba(0,0,0,1) 15%, rgba(35,29,60,1) 39%, rgba(73,43,88,1) 67%, rgba(42,89,88,1) 100%)';

const Page = ({
  children,
  title = '',
  showHeader = true,
  showFooter = true,
  fixedFooter = true,
  background = linearGradient,
  backgroundImage,
  backgroundSize,
  showTitle,
  ...rest
}: any) => {
  useLogPageView(title);

  return (
    <Wrapper background={background}>
      <Helmet title={`EulerBeats | ${title}`} />

      <>
        {showHeader && <Header />}

        <Flex justifyCenter {...rest}>
          <Content
            minHeight={['calc(100vh - 203px);', 'calc(100vh - 203px);', 'calc(100vh - 260px);']}
            {...rest}
          >
            <WarningMessage />
            {showTitle && (
              <Box my={3} fontSize={20} fontWeight="bold">
                {title}
              </Box>
            )}
            <div>{children}</div>
          </Content>
        </Flex>

        {showFooter && <Footer fixed={fixedFooter} />}
      </>
    </Wrapper>
  );
};

export default Page;
